import axios from "axios";
export { apiError } from "../lib/api";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "vs_website_admin_token";

export const siteApi = axios.create({ baseURL: API });
export const cmsApi = axios.create({ baseURL: API });

cmsApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const mediaUrl = (id) => (id ? `${API}/website/media/${id}` : null);

export const fmtPrice = (n) =>
  n === null || n === undefined || n === "" ? null : new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n));

export const DAYS = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"];

export const fmtDate = (iso) => (iso ? new Date(iso + (iso.length === 10 ? "T00:00:00" : "")).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" }) : "");

export async function uploadMedia(file, kind = "general") {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("kind", kind);
  const r = await cmsApi.post("/website-admin/media/upload", fd);
  return r.data;
}
